import { useState } from 'react';

const faqs = [
  {
    q: "J'ai zéro expérience en Bourse, est-ce que je peux quand même suivre cette méthode ?",
    a: "Absolument ! La méthode LS INVEST est pensée pour les débutants complets. Le Module 1 repart des bases et chaque module est progressif. Tu n'as besoin d'aucun prérequis.",
  },
  {
    q: 'Combien de temps faut-il consacrer à la formation ?',
    a: "Les modules sont conçus pour être consommés à ton rythme. En moyenne, 2 à 3h par semaine suffisent pour progresser significativement. Tu gardes accès à vie au contenu.",
  },
  {
    q: "Faut-il un gros capital pour commencer à investir en Bourse ?",
    a: "Non. Tu peux commencer avec 50€ par mois. La méthode t'apprend à construire progressivement ton portefeuille, peu importe ton budget de départ.",
  },
  {
    q: 'Est-ce que la méthode LS INVEST est vraiment gratuite ?',
    a: "L'accès à la formation complète est offert gratuitement. Il te suffit de t'inscrire avec ton prénom et ton email pour recevoir ton accès immédiatement.",
  },
  {
    q: 'La méthode fonctionne-t-elle vraiment ?',
    a: "Les résultats de nos membres parlent d'eux-mêmes. Des centaines de personnes ont appliqué la méthode LS INVEST et ont vu leur portefeuille progresser. Les performances passées ne garantissent pas les performances futures, mais la méthode, elle, est solide.",
  },
];

const FAQItem = ({ q, a }: { q: string; a: string }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-[#E2D9F3] rounded-xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-[#F5F0FF] transition-colors cursor-pointer"
      >
        <span className="text-[#1E0750] font-semibold text-sm pr-4">{q}</span>
        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
          <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-[#7B35ED] text-lg`} />
        </div>
      </button>
      {open && (
        <div className="px-6 py-4 bg-[#F5F0FF] border-t border-[#E2D9F3]">
          <p className="text-[#1E0750]/70 text-sm leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
};

const FAQSection = () => (
  <section className="bg-[#F5F0FF] py-16 px-8 lg:px-16">
    <div className="max-w-[860px] mx-auto">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-14 h-14 flex items-center justify-center bg-[#1E0750] rounded-2xl flex-shrink-0">
          <i className="ri-question-line text-[#A3E635] text-2xl" />
        </div>
        <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl">FAQ</h2>
      </div>
      <div className="flex flex-col gap-3">
        {faqs.map((f, i) => (
          <FAQItem key={i} q={f.q} a={f.a} />
        ))}
      </div>
    </div>
  </section>
);

export default FAQSection;
